import useCustomerFilterForm from 'Pages/customer/hooks/useCustomerFilterForm'
import { CategoryInput } from '../../../../common/form/input/_categoryInput'

export const CustomerInfo = () => {
  const { customerInfo } = useCustomerFilterForm()
  return (
    <CategoryInput
      className={'customer-filter-form__input-wide'}
      categoryList={[]}
      categoryValue={{ name: 'Tên khách hàng/Số điện thoại', value: '' }}
      categoryWidth={200}
      placeholder='Nhập Tên khách hàng/Số điện thoại'
      value={customerInfo?.value || ''}
      onChange={customerInfo.onChange}
      style={{ position: 'relative' }}
    />
  )
}
